"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERMS_AND_CONDITIONS = void 0;
var TERMS_AND_CONDITIONS = {
    title: "Terms & Conditions",
    lastModified: "25 September 2026",
    sections: [
        {
            heading: "Introduction",
            blocks: [
                {
                    type: "paragraph",
                    text: "These Terms & Conditions (“Terms”) govern your access to and use of the Cannaledger console, websites, mobile applications and related services (collectively the “Services”) provided by Cannaledger (PTY) Limited (“Cannaledger”, “we”, “us” or “our”).",
                },
                {
                    type: "paragraph",
                    text: "By creating an account, signing in to or otherwise using the Services, you confirm that you have read, understood and agree to be bound by these Terms and by our Privacy Policy. If you do not agree, you may not use the Services.",
                },
                {
                    type: "paragraph",
                    text: "If you use the Services on behalf of a company or other organisation (“Client”), you confirm that you have the authority to bind that Client to these Terms, and “you” includes that Client.",
                },
            ],
        },
        {
            heading: "Definitions",
            blocks: [
                {
                    type: "list",
                    items: [
                        { text: "“Account” means the user account created for you to access the Services." },
                        { text: "“Client Data” means all data, records and content captured in or uploaded to the Services by you or your Users." },
                        { text: "“Subscription” means the paid plan selected by the Client that sets out the features and fees applicable to its use of the Services." },
                        { text: "“User” means any individual invited by the Client to access the Services under the Client’s Subscription." },
                    ],
                },
            ],
        },
        {
            heading: "Eligibility and accounts",
            blocks: [
                {
                    type: "list",
                    items: [
                        { text: "You must be at least 18 years old and legally able to enter into a binding agreement to use the Services." },
                        { text: "You must provide accurate, current and complete information when creating your Account and keep it up to date." },
                        {
                            text: "You are responsible for keeping your login details confidential and for all activity that takes place under your Account. You must notify us immediately at sales@cannaledger.com if you suspect any unauthorised access to your Account.",
                        },
                        {
                            text: "Client administrators are responsible for the Users they invite, the roles and permissions they assign, and for removing access for Users who should no longer have it.",
                        },
                    ],
                },
            ],
        },
        {
            heading: "Use of the Services",
            blocks: [
                {
                    type: "paragraph",
                    text: "Subject to these Terms and payment of the applicable fees, we grant the Client a limited, non-exclusive, non-transferable right for its Users to access and use the Services for the Client’s internal business purposes during the term of its Subscription.",
                },
                { type: "paragraph", text: "You agree that you will not:" },
                {
                    type: "list",
                    items: [
                        { text: "use the Services for any unlawful purpose, or in breach of any licence, permit or regulation that applies to your operation;" },
                        { text: "attempt to access data, accounts or systems that do not belong to you or your Client;" },
                        { text: "copy, modify, reverse engineer, decompile or create derivative works of the Services;" },
                        { text: "interfere with or disrupt the integrity, security or performance of the Services, including by introducing malicious code;" },
                        { text: "resell, sublicense or otherwise make the Services available to any third party not authorised under the Client’s Subscription; or" },
                        { text: "use the Services to capture or transmit information that is false, misleading or infringes the rights of others." },
                    ],
                },
            ],
        },
        {
            heading: "Regulatory compliance",
            blocks: [
                {
                    type: "paragraph",
                    text: "The Services are a tool to help you manage cultivation operations, standard operating procedures and records. You remain solely responsible for complying with all laws, licence conditions and regulatory requirements that apply to your business, including any reporting to regulators. Cannaledger does not provide legal, regulatory or agricultural advice, and use of the Services does not guarantee compliance.",
                },
            ],
        },
        {
            heading: "Client Data",
            blocks: [
                {
                    type: "list",
                    items: [
                        { text: "The Client retains all ownership rights in its Client Data." },
                        {
                            text: "You grant Cannaledger a non-exclusive right to host, store, process and display Client Data only as needed to provide, maintain and improve the Services, and as otherwise described in our Privacy Policy.",
                        },
                        {
                            text: "You are responsible for the accuracy, quality and legality of Client Data and for having the rights needed to capture it in the Services.",
                        },
                        {
                            text: "We may use anonymised and aggregated data that does not identify you, your Client or any individual to operate, analyse and improve the Services.",
                        },
                    ],
                },
            ],
        },
        {
            heading: "Privacy",
            blocks: [
                {
                    type: "paragraph",
                    text: "We process personal information in accordance with the Protection of Personal Information Act, No. 4 of 2013 (“POPIA”) and, where applicable, other data protection laws, as set out in our Privacy Policy. The Privacy Policy forms part of these Terms.",
                },
            ],
        },
        {
            heading: "Subscriptions, fees and payment",
            blocks: [
                {
                    type: "list",
                    items: [
                        {
                            text: "Fees for the Services are set out in the Client’s Subscription and are payable in advance for each billing period unless otherwise agreed in writing.",
                        },
                        { text: "Subscriptions renew automatically at the end of each billing period unless cancelled before the renewal date." },
                        { text: "All fees are exclusive of VAT and other applicable taxes unless stated otherwise." },
                        {
                            text: "If a payment fails or remains outstanding, we may suspend access to the Services until the account is brought up to date. Access will be restored once payment is received.",
                        },
                        { text: "Except where required by law, fees already paid are non-refundable." },
                        { text: "We may change our fees on at least 30 days’ written notice, effective from the next billing period." },
                    ],
                },
            ],
        },
        {
            heading: "Third-party integrations",
            blocks: [
                {
                    type: "paragraph",
                    text: "The Services may allow you to connect third-party devices, platforms or services. Your use of those third-party products is governed by their own terms, and Cannaledger is not responsible for their availability, accuracy or security. By connecting an integration, you authorise us to exchange data with that third party as needed to provide the integration.",
                },
            ],
        },
        {
            heading: "Intellectual property",
            blocks: [
                {
                    type: "paragraph",
                    text: "Cannaledger and its licensors own all rights, title and interest in and to the Services, including all software, designs, trademarks and documentation. Nothing in these Terms transfers any of those rights to you, other than the limited right to use the Services described above. Any feedback you give us about the Services may be used by us without restriction or obligation to you.",
                },
            ],
        },
        {
            heading: "Availability and support",
            blocks: [
                {
                    type: "paragraph",
                    text: "We will use reasonable efforts to keep the Services available and secure, but we do not guarantee that they will be uninterrupted or error-free. We may carry out scheduled or emergency maintenance and may add, change or remove features from time to time. Where reasonably possible, we will give advance notice of planned downtime or material changes.",
                },
            ],
        },
        {
            heading: "Disclaimer and limitation of liability",
            blocks: [
                {
                    type: "list",
                    items: [
                        {
                            text: "To the fullest extent permitted by law, the Services are provided “as is” and “as available”, without warranties of any kind, whether express or implied, including warranties of merchantability, fitness for a particular purpose and non-infringement.",
                        },
                        {
                            text: "Cannaledger will not be liable for any indirect, incidental, special or consequential loss, including loss of profits, crops, revenue, data or business opportunity, arising from or related to your use of the Services.",
                        },
                        {
                            text: "Our total liability for any claim arising from or related to these Terms or the Services will not exceed the fees paid by the Client for the Services in the twelve (12) months before the event giving rise to the claim.",
                        },
                        {
                            text: "Nothing in these Terms limits any liability that cannot be limited or excluded under applicable law, including the Consumer Protection Act, No. 68 of 2008, where it applies.",
                        },
                    ],
                },
            ],
        },
        {
            heading: "Indemnity",
            blocks: [
                {
                    type: "paragraph",
                    text: "You agree to indemnify and hold Cannaledger harmless against any claims, losses, damages and costs (including reasonable legal fees) arising from your breach of these Terms, your Client Data, or your violation of any law or the rights of a third party.",
                },
            ],
        },
        {
            heading: "Suspension and termination",
            blocks: [
                {
                    type: "list",
                    items: [
                        { text: "You may stop using the Services and cancel the Client’s Subscription at any time, effective at the end of the current billing period." },
                        {
                            text: "We may suspend or terminate access to the Services immediately if you materially breach these Terms, fail to pay fees when due, or if required by law.",
                        },
                        {
                            text: "On termination, your right to use the Services ends. The Client may request an export of its Client Data within 30 days of termination, after which we may delete it, subject to any legal retention obligations.",
                        },
                        {
                            text: "Sections that by their nature should survive termination, including those on fees owed, intellectual property, liability and indemnity, will continue to apply.",
                        },
                    ],
                },
            ],
        },
        {
            heading: "Changes to these Terms",
            blocks: [
                {
                    type: "paragraph",
                    text: "We may update these Terms at any time. If we do, we will update the “last modified” date at the bottom of these Terms and ask you to accept the updated Terms before you continue using the Services. If you do not accept the updated Terms, you must stop using the Services.",
                },
            ],
        },
        {
            heading: "Governing law and disputes",
            blocks: [
                {
                    type: "paragraph",
                    text: "These Terms are governed by the laws of the Republic of South Africa. Any dispute arising from these Terms or the Services will first be referred to good-faith negotiation between the parties. If the dispute is not resolved within 30 days, either party may refer it to a competent court in South Africa.",
                },
            ],
        },
        {
            heading: "General",
            blocks: [
                {
                    type: "list",
                    items: [
                        {
                            text: "These Terms, together with the Privacy Policy and the Client’s Subscription, form the entire agreement between you and Cannaledger regarding the Services.",
                        },
                        { text: "If any provision of these Terms is found to be unenforceable, the remaining provisions will continue in full force and effect." },
                        { text: "Our failure to enforce any right under these Terms does not waive that right." },
                        { text: "You may not transfer your rights or obligations under these Terms without our prior written consent." },
                    ],
                },
            ],
        },
        {
            heading: "How to contact us",
            blocks: [
                {
                    type: "paragraph",
                    text: "If you have any questions about these Terms, please contact us by email at sales@cannaledger.com or by phone on +27 76 855 6011.",
                },
            ],
        },
    ],
};
exports.TERMS_AND_CONDITIONS = TERMS_AND_CONDITIONS;
